<script lang="ts">
  export let rating: number
</script>

<div class="auws-rating-dots">
  {#each [0, 1, 2, 3, 4] as dot}
    <span
      class="auws-rating-dot"
      data-rating={rating && dot < rating ? rating : null}
    />
  {/each}
</div>

<style>
  .auws-rating-dots {
    display: flex;
    gap: 2px;
  }

  .auws-rating-dots .auws-rating-dot {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--au-rating-0-color);
  }

  .auws-rating-dots .auws-rating-dot[data-rating="1"] {
    background-color: var(--au-rating-1-color);
  }

  .auws-rating-dots .auws-rating-dot[data-rating="2"] {
    background-color: var(--au-rating-2-color);
  }

  .auws-rating-dots .auws-rating-dot[data-rating="3"] {
    background-color: var(--au-rating-3-color);
  }

  .auws-rating-dots .auws-rating-dot[data-rating="4"] {
    background-color: var(--au-rating-4-color);
  }

  .auws-rating-dots .auws-rating-dot[data-rating="5"] {
    background-color: var(--au-rating-5-color);
  }
</style>
